import { useSearchParams } from "react-router-dom";

import { IS_IN_IFRAME } from "@src/env";
import { useAuthTokenFromParent } from "@src/features/iframe";
import { navigationV2 } from "@src/shared/navigation/v2";

import { authClient } from "../../data";

export function useIframeAuthLoginFlow() {
  const [searchParams] = useSearchParams();
  const {
    data: session,
    isPending: isPendingSession,
    error: sessionError,
    refetch,
  } = authClient.useSession();

  useAuthTokenFromParent(refetch);

  const sessionErrorMessage = sessionError?.message
    ? "Unable to verify your session. Please try logging in again."
    : null;
  const errorFromUrl = searchParams.get("error");

  return {
    destinations: {
      home: () => navigationV2.home(),
      patient: (patientId: string) => navigationV2.patientDetail(patientId),
    },
    enabled: IS_IN_IFRAME,
    error: errorFromUrl || sessionErrorMessage,
    isLoading: isPendingSession,
    session,
  } as const;
}
